import React, { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'success' | 'warning' | 'danger' | 'info' | 'outfront' | 'secondary' | 'outline';
}

export default function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  const variants = {
    default: 'bg-neutral-100 text-neutral-600',
    success: 'bg-status-positive-bg text-status-positive',
    warning: 'bg-status-warning-bg text-status-warning',
    danger: 'bg-status-negative-bg text-status-negative',
    info: 'bg-outfront-purple-light text-outfront-purple',
    outfront: 'bg-outfront-purple-light text-outfront-purple',
    secondary: 'bg-neutral-200 text-neutral-600',
    outline: 'border border-neutral-200 bg-transparent text-neutral-600',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center rounded px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide',
        variants[variant],
        className
      )}
      {...props}
    />
  );
}

export { Badge };
